import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

import GeoLocationComponent from 'components/GeoLocationComponent/GeoLocationComponent';

import generateUUID from 'utils/sharedUtils/generateUUID';

import { useCreateAor, useUpdateAor } from 'hooks/useAors';

import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import StylishNewInput from 'components/DesignSystems/New/StylishNewInput';
import StylishNewTextArea from 'components/DesignSystems/New/StylishNewTextArea';

export default function AORCreationDialog({
  show,
  onClose,
  existingAOR = null,
}) {
  const reduxDispatch = useDispatch();
  const createAor = useCreateAor();
  const updateAor = useUpdateAor();

  const [isLoaded, setIsLoaded] = useState(true);

  const reduxCurrentlySelectedGroup = useSelector((state) => {
    return state.app.currentlySelectedGroup;
  });

  const [name, setName] = useState(
    (!!existingAOR && !!existingAOR.name && existingAOR.name) || ''
  );
  const [description, setDescription] = useState(
    (!!existingAOR && !!existingAOR.description && existingAOR.description) || ''
  );
  const [location, setLocation] = useState(
    !!existingAOR && !!existingAOR.location && existingAOR.location
  );

  useEffect(() => {
    if (!isLoaded && (createAor.isSuccess || updateAor.isSuccess)) {
      onClose();
    }
  }, [createAor.isSuccess, updateAor.isSuccess, isLoaded, onClose]);

  function createAOR() {
    const current_location_geom =
      !!location &&
      !!location.geojson &&
      location.geojson.data.features[0].geometry;
    const aor = {
      id: (!!existingAOR && existingAOR.id) || generateUUID(),
      group_guid: reduxCurrentlySelectedGroup.group_guid,
      name: name,
      description: description,
      location: location,
      current_location_geom: current_location_geom,
    };
    return aor;
  }

  const handleAORCreateClick = () => {
    setIsLoaded(false);
    const aor = createAOR();
    if (existingAOR) {
      updateAor.mutate(aor);
    } else {
      createAor.mutate(aor);
    }
  };

  const saveName =
    (!!existingAOR && existingAOR.name) || "AOR";

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>
          {(!!existingAOR && <>Edit {existingAOR.name}</>) || (
            <>New AOR</>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <StylishNewInput
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <StylishNewTextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="m-0">
          <label className="form-label">Location</label>
          <GeoLocationComponent
            location={location}
            setLocation={setLocation}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="button-group">
          <StylishNewButton
            type="button"
            className="button--secondary button--reverse"
            onClick={onClose}
          >
            Cancel
          </StylishNewButton>
          <StylishNewButton
            className="button--primary"
            disabled={!isLoaded || !name}
            onClick={() => handleAORCreateClick()}
          >
            Save {saveName}
          </StylishNewButton>
        </div>
      </Modal.Footer>
      {!isLoaded && <div>loading...</div>}
    </Modal>
  );
}
